module.exports = __webpack_public_path__ + "static/media/Marker1.18f90153.svg";